import { useState } from 'react';

import './BrandTrackingHealth.scss';
import BrandTrackingHealthData from './BrandTrackingHealthData';
import BrandTrackingHealthRow from './BrandTrackingHealthRow';
import BrandTrackingHealthDetail from './BrandTrackingHealthDetail';

const SKELETON_ROW_COUNT = 6;

const BrandTrackingHealth = () => {
  const [curSearchVal, setCurSearchVal] = useState('');
  const [accountManagerId, setAccountManagerId] = useState('');
  const [sortBy, setSortBy] = useState('severity');
  const [accountManagers, setAccountManagers] = useState([]);
  const [results, setResults] = useState([]);
  const [brandStats, setBrandStats] = useState({});
  const [isFetching, setIsFetching] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(null);

  const sortedResults = sortBy === 'mrr' ? [...results].sort((a, b) => (b.mrr || 0) - (a.mrr || 0)) : results;

  if (selectedBrand) {
    return (
      <div className='brand-tracking-health-outer'>
        <BrandTrackingHealthDetail Brand_id={selectedBrand.Brand_id} brandName={selectedBrand.name} onBack={() => setSelectedBrand(null)} />
      </div>
    );
  }

  return (
    <div className='brand-tracking-health-outer'>
      <h1 className='brand-tracking-health-title'>Brand Tracking Health</h1>

      <div className='brand-tracking-health-controls'>
        <input
          className='brand-tracking-health-search'
          type='text'
          value={curSearchVal}
          placeholder='Search by brand name or domain'
          onChange={e => setCurSearchVal(e.target.value)}
        />
        <select className='brand-tracking-health-am-filter' value={accountManagerId} onChange={e => setAccountManagerId(e.target.value)}>
          <option value=''>All account managers</option>
          {accountManagers.map(accountManager => (
            <option key={accountManager.id} value={accountManager.id}>
              {accountManager.name}
            </option>
          ))}
        </select>
        <select className='brand-tracking-health-sort' value={sortBy} onChange={e => setSortBy(e.target.value)}>
          <option value='severity'>Sort: worst first</option>
          <option value='mrr'>Sort: highest MRR</option>
        </select>
      </div>

      <div className='brand-tracking-health-results'>
        {isFetching ? (
          Array.from({ length: SKELETON_ROW_COUNT }).map((_, idx) => <div key={idx} className='brand-tracking-health-loading-row' />)
        ) : results.length ? (
          sortedResults.map(brand => (
            <BrandTrackingHealthRow key={brand.Brand_id} brand={brand} stats={brandStats[brand.Brand_id]} onSelectBrand={setSelectedBrand} />
          ))
        ) : (
          <div className='brand-tracking-health-empty'>No brands match — every tracked brand is healthy.</div>
        )}
      </div>

      <BrandTrackingHealthData
        curSearchVal={curSearchVal}
        accountManagerId={accountManagerId}
        setResults={setResults}
        setIsFetching={setIsFetching}
        setAccountManagers={setAccountManagers}
        setBrandStats={setBrandStats}
      />
    </div>
  );
};

export default BrandTrackingHealth;
